import { useState } from "react"
import Sidebar from "../../components/sidebar/Sidebar"
import Navbar from "../../components/navbar/Navbar"
import Widget from "../../components/widget/Widget"
import Chart from "../../components/charts/Chart"
import List from "../../components/table/List"
import MapSection from "../../components/map/MapSection"
import "./home.css"

const Home = () => {
  const [collapsed, setCollapsed] = useState(false)

  return (
    <div className="home" style={{ display: "flex", minHeight: "100vh" }}>
      <Sidebar collapsed={collapsed} setCollapsed={setCollapsed} />
      <div className="homeContainer" style={{ flex: 1, overflow: "auto" }}>
        <Navbar />

        <div className="widgets-grid">
          <Widget type="hotels" />
          <Widget type="cafes" />
          <Widget type="events" />
          <Widget type="users" />
        </div>

        <div className="charts">
          <Chart aspect={3} />
        </div>

        <div className="mapRow">
          <MapSection />
        </div>

        <div className="listContainer">
          <div className="listTitle">Dernières créations</div>
          <List />
        </div>
      </div>
    </div>
  )
}

export default Home